import { SALESFORCE_FIELD_MAX_LENGTH, exceedsFieldLength } from '../../constants';

import type { BlackoutFormValues } from './types';

// Mirrors svc-offer `pricingToolDraftValidator.ts` blackout rules: real ISO YYYY-MM-DD
// dates and startDate on or before endDate. Name presence is required by the schema's
// minLength: 1.
const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

export function isIsoDate(value: string): boolean {
  const match = ISO_DATE_PATTERN.exec(value);

  if (!match) {
    return false;
  }

  const [year, month, day] = match.slice(1).map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));

  return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
}

export const BLACKOUT_NAME_TOO_LONG = `Name must be ${SALESFORCE_FIELD_MAX_LENGTH.blackoutName} characters or fewer.`;

export function validateBlackout(values: BlackoutFormValues): Array<string> {
  const errors: Array<string> = [];

  if (!values.name || values.name.trim().length < 1) {
    errors.push('Name is required.');
  }

  if (exceedsFieldLength(values.name, SALESFORCE_FIELD_MAX_LENGTH.blackoutName)) {
    errors.push(BLACKOUT_NAME_TOO_LONG);
  }

  if (!isIsoDate(values.startDate)) {
    errors.push('Start date must be a real ISO YYYY-MM-DD date.');
  }

  if (!isIsoDate(values.endDate)) {
    errors.push('End date must be a real ISO YYYY-MM-DD date.');
  }

  if (isIsoDate(values.startDate) && isIsoDate(values.endDate) && values.startDate > values.endDate) {
    errors.push('Start date must be on or before end date.');
  }

  return errors;
}
